<template>
  <div class="scan">
    <top :toolSort="toolSort"></top>
    <div v-show="!hasPic">
      <div class="main" >
        <div class="excelBgTop">
          <el-card>
            <div class="leftBg">
              <div :class="['excelDesc',{ mobileFontSize: $isMobile }]" >
                <div :class="['addFileType' ,{ mobileFontSize: $isMobile }]">+图片或pdf文件</div>
               <div :class="['descInfo',{ mobileFontSize: $isMobile }]">
                  如上传图片，请保证文件清晰度，
               </div>
              </div>
               <img src="../../assets/images/excel.jpg" />
            </div>
          </el-card>
        <div v-if="$isMobile" class="mobileDivider">
          <el-divider direction="vertical" class="divider"></el-divider>
        </div>
        <div v-else class="PCdivider">
          <el-divider direction="vertical" class="divider"></el-divider>
        </div>  
          <div  :class="['PCuploadOperate' ,{ mobileUploadOperate: $isMobile }]">
            <el-form>
              <el-form-item label="请选择类型">
                <el-radio v-model="type" label="1">图片</el-radio>
                <el-radio v-model="type" label="2">pdf</el-radio>
              </el-form-item>
            </el-form>
            <el-upload :accept="acceptType" ref='upload' action=""
            :multiple='true'
              :on-change='onChange' :file-list="fileList" :auto-upload="false" list-type="picture-card" :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">只能上传图片或pdf类型文件，且不超过10M</div>
            </el-upload>
          </div>
        </div>
      </div>
<div class="btn">
          <el-button type="primary" @click='scaneImgs'>确定</el-button>
          <el-button @click='$router.go(-1)'>返回</el-button>
        </div>
    </div>
   <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <div class="result" v-show="hasPic">
      <div class="left">
        <img src="" />
        <div id="pdfList">
          <el-checkbox-group v-model="checkAll" @change="handleCheckAllChange">

            <el-checkbox  :checked="allChecked" :disabled="canvasImgs.length>3" :indeterminate="isIndeterminate">全选(最多选择三张)</el-checkbox>
          </el-checkbox-group>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedPages" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="(item,i) in canvasImgs" :key='i' :label="item.src">
              <el-card shadow="hover">
                <div>
                  <p>第{{i+1}}页</p>
                  <img @click.prevent="preViewPdf(item.src)" :class="{canvasImgSmall:canvasImgs.length>4,canvasImg:canvasImgs.length<=4}"
                    :src="item.src" />
                </div>
              </el-card>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="right">
        <div class="uploadbtn">
          <el-button size="mini" type="primary" @click='uploadMore'>继续上传</el-button>
        </div>
        <el-card>
          <el-table :data="files">
            <el-table-column prop="name" label="文件名称"></el-table-column>
            <el-table-column prop="pages" width="50" label="页数"></el-table-column>
            <el-table-column label="页码选择" width="180">
              <template >
                <el-select v-model="checkedPages" multiple placeholder="全部">
                  <el-option v-for="(item,i) in canvasImgs" :key="i" :label="i+1" :value="item.src">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120">
              <template >
                <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template >
                <div class="scanBtn">
                  <el-button size="mini" :disabled="checkedPages.length === 0" @click='pdf2excel' type="warning">开始转换</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="resultfiles">
          <p></p>
          <div class="resultInfo">
            <div class="resultTitle">
              扫描结果
            </div>
            <el-button size="mini" type="primary" @click='downWrap' :disabled="resultfiles.length === 0">批量下载</el-button>
          </div>
          <p></p>
          <el-card>
            <el-table :data="resultfiles">
              <el-table-column label="文件名称" prop="name"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope='scope'>
                  <el-button size='mini' type="primary" @click='downLoad(scope.row)'>下载</el-button>
                  <el-button size="mini" type="danger" @click='deleteFile(scope.row,scope.$index)'>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const PDFJS = require('pdfjs-dist');
import JSZip from "jszip";
  PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry');
  import top from '../subComponents/top.vue'
  import FileSaver from "file-saver";
  import qs from 'qs';
  import axios from 'axios'
  export default {
    data() {
      return {
        acceptType:'.jpg,.png,.jpeg',//允许上传的文件类型
        type:'1',
        allChecked:false,
        canvasImgsOptions:[],
        isImg: false, //判断上传的是否是图片
        resultfiles: [],
        percentage: 0,
        isIndeterminate: false,
        checkAll: false,
        checkedPages: [],
        canvasImgs: [],
        files: [],
        hasPic: false, //是否已有图片
        pages: [],
        scaning: false,
        toolSort: '',
        imageUrl: '',
        fileList: [],
        exceedError: '',
        dialogVisible: false,
        dialogImageUrl: '',
      }
    },
    created() {
      this.toolSort = this.$route.params.sort
    },
    watch:{
      type(val){
        if(val === '1'){
          this.acceptType = '.jpg,.png,.jpeg'
        }else{
          this.acceptType = '.pdf'
        }
      },
      checkedPages(val){
        if(val.length === this.canvasImgsOptions.length){
          this.allChecked = true
          this.isIndeterminate = false
        }
        if(val.length !== this.canvasImgsOptions.length && val.length !== 0){
          this.isIndeterminate = true
          this.allChecked = false
        }if(val.length === 0){
          this.isIndeterminate = false
          this.allChecked = false
        }
        this.$forceUpdate()
      }
    },
    methods: {
      scaneImgs(){
        this.canvasImgsOptions = []
        this.hasPic = true
        this.files.push({name:'图片',pages:this.fileList.length})
        this.fileList.forEach((item,i)=>{
          this.canvasImgs.push({src:item.url})
          this.canvasImgsOptions.push(item.url)
        })
      },
      getFile(url,contentType){
        return new Promise((resolve, reject) => {
          let blob = this.base64ToBlob(url,contentType)
          resolve(blob)
         })
      },
      // 批量打包下载
      downWrap() {
         const zip = new JSZip();
              const cache = {};
              const promises = [];
              const downFiles = JSON.parse(JSON.stringify(this.resultfiles));
              downFiles.forEach((item) => {
                const promise = this.getFile(
                 item.src,'application/vnd.ms-excel'
                ).then((data) => {
                  let namearr = this.fileList[0].name.split('.')
                  const fileName = item.name + '.xls'
                  zip.file(fileName, data, {
                    binary: true,
                  }); // 逐个添加文件
                  cache[fileName] = data;
                });
                promises.push(promise);
              });

              Promise.all(promises).then(() => {
                zip
                  .generateAsync({
                    type: "blob",
                  })
                  .then((content) => {
                    // 生成二进制流
                    FileSaver.saveAs(content, "打包下载.zip"); // 利用file-saver保存文件
                  });
              });
      },
      uploadMore() {
        this.hasPic = false;
        this.fileList = []
        this.$refs.upload.clearFiles()
        this.resultfiles = []
        this.checkedPages = []
        this.files = []
        this.percentage = 0
        this.canvasImgs = []
        this.canvasImgsOptions = []
      },
      deleteFile(row, index) {
        this.resultfiles.splice(index, 1)
      },
      //base64转blob
      base64ToBlob(code, contentType) {
        let raw = window.atob(code);
        let rawLength = raw.length;
        let uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
          type: contentType
        });
      },
      //下载
      downLoad(row) {
        let downloadElement = document.createElement("a");
        let blob = this.base64ToBlob(row.src, 'application/vnd.ms-excel')
        let href = blob;
        if (typeof blob === "string") {
          downloadElement.target = "_blank";
        } else {
          href = window.URL.createObjectURL(blob); // 创建下载的链接
        }
        downloadElement.href = href;
        downloadElement.download = row.name; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        if (typeof blob !== "string") {
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        }
      },

      handleCheckAllChange(val) {
        this.checkedPages = val ? this.canvasImgsOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        if(this.checkedPages.length > 3){
          this.checkedPages.pop()
        }
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.canvasImgs.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.canvasImgs.length;
      },
      preViewPdf(src) {
        this.dialogVisible = true
        this.dialogImageUrl = src
      },
      pdf2excel() {
        this.resultfiles = []
        let params = []
        if(this.isImg){
          this.fileList.forEach(item=>{
            this.checkedPages.forEach(item2=>{
              if(item2 === item.url){
                params.push(item.raw)
              }
            })
          })
        }else{
          params = this.checkedPages
        }
        if (!this.isImg) {
          params = params.map(item => {
            item = this.dataURLtoFile(item, this.fileList[0].name)
            return item
          })
        }
        this.scanImg2excel(params)

        var strLength = this.checkedPages[0].length;
        var fileLength = parseInt(strLength - (strLength / 8) * 2);

        // 由字节转换为KB
        var size = "";
        size = (fileLength / 1024).toFixed(2);
      },

      dataURLtoFile(dataurl, filename) { //将base64转换为文件
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
          type: mime
        });
      },

      async showPdf() {
        this.canvasImgsOptions = []
        let reader = new FileReader();
        reader.readAsDataURL(this.fileList[0].raw);
        reader.onload = () => {
          let pdfList = document.querySelector('#pdfList') //通过querySelector选择DOM节点,使用document.getElementById()也一样
          let base64 = reader.result //获得bas464编码
          base64 = base64.split(',')[1].replace(/%/g, '%25').replace(/-/g, "+").replace(/_/g, "/")
          let decodedBase64 = atob(base64); //使用浏览器自带的方法解码
          //返回一个pdf对象
          PDFJS.getDocument({
            data: decodedBase64
          }).promise.then(async pdf => {
            let pages = pdf.numPages //声明一个pages变量等于当前pdf文件的页数
            this.files.push({
              name: this.fileList[0].name,
              pages
            })
            this.canvasImgs = []
            for (let i = 1; i <= pages; i++) { //循环页数
              let canvas = document.createElement('canvas')
              let page = await pdf.getPage(i) //调用getPage方法传入当前循环的页数,返回一个page对象
              let scale = 2 //缩放倍数，1表示原始大小
              let viewport = page.getViewport({
                scale
              });
              let ctx = canvas.getContext('2d'); //创建绘制canvas的对象
              canvas.height = viewport.height; //定义canvas高和宽
              canvas.width = viewport.width;
              let renderContext = {
                canvasContext: ctx,
                viewport: viewport
              };
              page.render(renderContext).promise.then(() => {
                let img = new Image()
                img.src = canvas.toDataURL()
                this.canvasImgs.push(img)
                this.canvasImgsOptions.push(img.src)
              })
            }
            this.hasPic = true
          }).catch(error => {
            console.log(error)
          })
        };

      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleRemove(file, fileList) {
        if (fileList.length === 0) {
          this.exceedError = '您暂未选择图片'
        } else {
          this.exceedError = ''
        }
        if (fileList.length === 1) {
          this.exceedError = ''
        }
        this.fileList = fileList
      },
      async onChange(file, FileList) {
        this.fileList = FileList

        const isLt1M = file.size / 1024 / 1024 < 10
        if (!isLt1M) {
          this.exceedError = '上传图片大小不能超过 10MB!'
        }
        let extend = ''
        let nameArr = this.fileList[0].name.split(".");
        let type = nameArr[nameArr.length - 1];
        if (this.exceedError) return this.hasPic = false
        if (!this.exceedError && type !== 'pdf') {
          this.isImg = true
        } else {
          this.isImg = false
          this.showPdf()
        }
        // this.hasPic = true
      },
      async scanImg2excel(file) {
        this.scaning = true
        let params = new FormData()
        file.forEach((item, i) => {
          params.append('url' + i, item)
        })

        let res = await this.$axios.post(this.$serviceAPI.scaneImgToExcel, params, {
          onUploadProgress: this.onUploadProgress
        })
        this.scaning = false
        if (res.data.code === 200) {
          this.message.success('识别成功，等待下载')
          this.checkedPages.forEach((item)=>{
            this.canvasImgs.forEach((item2,i)=>{
              if(item === item2.src){
                this.canvasImgs.splice(i,1)
                this.canvasImgsOptions.splice(i,1)
              }
            })
          })
          this.checkedPages = []
          let nameArr = this.fileList[0].name.split('.')
          nameArr = nameArr.splice(nameArr[nameArr.length-1],1)
          res.data.data.forEach((item, i) => {
            this.resultfiles.push({
              src: item,
              name: `${nameArr.join('.')}(${i+1})页`
            })
          })
        } else {
          this.message.error(res.data.message)
        }
      },
      onUploadProgress(progress) {
        this.percentage = Math.round(progress.loaded / progress.total * 100)
      }
    },
    components: {
      top
    }
  }
</script>

<style scoped="scoped">
  .main{
    display: flex;
  }
  .btn{
    display: flex;
    margin-top: 30px;
    justify-content: center;
  }
  .excelBgTop{
    margin-top: 20px;
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: start;
  }
  .PCuploadOperate{
    flex: 5;
  }
  .mobileUploadOperate{
    flex: 1;
  }
  .excelBgTop .el-card:nth-child(1){
    flex: 3;
  }
  .el-card__body { 
    padding: 1.8rem;
}x
  .leftBg{
    display: flex;
  }
  .el-divider--vertical{
      height: 100%;
  }
  .PCdivider,.mobileDivider{
    height: 100%;
  }
 .PCdivider .el-divider--vertical{
  margin: 0 100px;
}
 .mobileDivider .el-divider--vertical{
  margin: 0 10px;
}

  .leftBg img{
    width: 8rem;
    object-fit: contain;
    border-radius: 50%;
    opacity: .6;
    margin-left: -0.8rem;
  }
  .excelDesc{
    color: #888;
    line-height: 40px;
  }
  .addFileType{
    font-size: 1rem;
  }

  .descInfo{
    font-size: 0.5rem;
  }
  .resultInfo {
    display: flex;
    align-items: center;
  }
  .el-checkbox {
    margin-right: 5px;
  }
  .uploadbtn {
    margin-right: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .resultTitle {
    font-size: 14px;
    padding: 0.625rem;
    color: #409EFF;
  }
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .canvasImg {
    object-fit: contain;
    width: 180px;
    height: 280px;
  }
  .canvasImgSmall {
    object-fit: contain;
    width: 61px;
    height: 120px;
  }
  .result {
    display: flex;
  }
  .result .left {
    margin: 0 auto;
    flex: 4;
    border-right: 1px dotted #DDDDDD;
  }
  .result .right {
    margin: 0 auto;
    flex: 5;
    padding: 0.625rem;
    padding-top: 1.125rem;

  }
  .canvas {
    width: 100%;
  }
  .scanBtn {
    display: flex;
    justify-content: right;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/subPage/scanImgToExcel.vue